import React from 'react';

import LandingPageDesignWeb from './../../components/LandingPageDesignWeb';
import LandingPageDesignMobile from './../../components/LandingPageDesignMobile';
import { Col, Row } from 'antd';
import Content from './content';

function Detail(props) {

  return (
    <Row>
      <Col
        xs={{ span: 0 }}
        sm={{ span: 24 }}
        md={{ span: 24 }}
        lg={{ span: 24 }}
        xl={{ span: 24 }}
        xxl={{ span: 24 }}
        style={{ margin: 0 }}
      >
        <LandingPageDesignWeb Children={Content} {...props} />
      </Col>
      <Col
        xs={{ span: 24 }}
        sm={{ span: 24 }}
        md={{ span: 24 }}
        lg={{ span: 24 }}
        xl={{ span: 24 }}
        xxl={{ span: 24 }}
        style={{ margin: 0 }}
      >
        <LandingPageDesignMobile Children={Content}  {...props} />
      </Col>

    </Row>
  );
}

export default Detail;
